import { hasConfigDataUrl } from 'components.modules.gen/placeholder-dataurl/dataUrl-main.js';
import { DataUrlComponent } from 'components.modules.gen/placeholder-dataurl/dataUrlComponent.js';
import { ConfigWithDataUrl } from 'components.modules.gen/placeholder-dataurl/dataUrlHook.js';
import { RenderSuspenseComponent } from 'components.modules.gen/placeholder-dataurl/renderSuspenseComponent.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { HasConfigDataUrlHook } from 'redux-state/modules-dataurl/utils.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { predicateBoolean } from 'utilities/isType.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { getModuleComponentWithErrorBoundary } from './module-build.js';
import { MobileSecondaryMajorModuleWrapper } from './module-load-secondary-section.js';

/** Lazy load module */
export const ModuleLoad = ({
  config: coreConfig,
  modulePath,
  isDrawer,
  wrapInSecondarySectionDrawer = false,
}: {
  config: IModuleConfig;
  modulePath: ModulePath;
  isDrawer?: boolean;
  /** We need to use this pattern as the module config can only load once, use a seperate components
   * to wrap mobile logic this will cause multiple re-renders which affects ads and re-render issues */
  wrapInSecondarySectionDrawer?: boolean;
}) => {
  const { merged, moduleConfig: module } = HasConfigDataUrlHook({ config: coreConfig });
  /** Do nothing until we know if the module is merged or not */
  if (predicateBoolean(merged)) {
    if (!module.name) {
      messageLog.error('Error: Module Has No Name', ['config', module]);
      return null;
    }
    if (!merged && hasConfigDataUrl(module)) {
      /** Make fetch request for addutional data  */
      return (
        <MobileSecondaryMajorModuleWrapper module={module} wrapInSecondarySectionDrawer={wrapInSecondarySectionDrawer}>
          <DataUrlComponent
            key={`${module.name}-${module?.key ?? ''}`}
            isDrawer={isDrawer}
            modulePath={modulePath}
            config={module as ConfigWithDataUrl}
            // needed to get load data url
            childModuleName={module.name}
          />
        </MobileSecondaryMajorModuleWrapper>
      );
    }

    const ModuleComponent = getModuleComponentWithErrorBoundary(module.name);
    if (ModuleComponent) {
      return (
        <MobileSecondaryMajorModuleWrapper module={module} wrapInSecondarySectionDrawer={wrapInSecondarySectionDrawer}>
          <RenderSuspenseComponent
            key={`${module.name}-${module?.key ?? ''}`}
            config={module}
            isDrawer={isDrawer}
            modulePath={modulePath}
            childModuleName={module.name}
          >
            {ModuleComponent}
          </RenderSuspenseComponent>
        </MobileSecondaryMajorModuleWrapper>
      );
    }
  }

  return null;
};
